import { API_BASE_URL } from '@/libs/apiBase'
import type { IPublicBrand } from '@/types/Tenant'
import type { IConfig } from '@/types/User'

/*
 * Whether this host is only for screen sharing — the deployment's SHARE_DOMAIN (GET /config) or
 * a look's share domain (GET /public/brand → share_host) — so the router opens the share page at
 * its root instead of the console's login. A leaf module with plain fetch: the router awaits it
 * before the first navigation, and the fetch store waits on the router (a cycle that hung the
 * page in 1.18.0). Asked once per load; a failed answer is "no".
 */
let answer: Promise<boolean> | null = null

const read = async <T>(path: string): Promise<T | null> => {
    try {
        const response = await fetch(API_BASE_URL + path, { headers: { Accept: 'application/json' } })

        return response.ok ? (await response.json()) as T : null
    } catch {
        return null
    }
}

export const isShareHost = (): Promise<boolean> => {
    answer ??= (async (): Promise<boolean> => {
        const host = window.location.host.toLowerCase()
        const config = await read<IConfig>('/config')

        if (config?.share_domain && config.share_domain === host) return true

        const brand = await read<IPublicBrand | null>('/public/brand')

        return brand?.share_host === true
    })()

    return answer
}
